<div class="page-wrapper" [ngClass]="{'toggled': show}">
  <app-layout-sidebar/>
  <main class="page-content  bg-white dark:bg-neutral-800">
    <app-layout-navbar (showChange)="updateShow($event)"/>
    <ng-content></ng-content>

    <footer class="shadow dark:shadow-gray-700 bg-white dark:bg-neutral-900 px-6 py-4">

      <div class="container-fluid">
        <div class="grid grid-cols-1">
          <div class="sm:text-start text-center mx-md-2">
            <p class="mb-0 text-neutral-400">
               &copy; {{ year }} Quality Digital. Versão: {{ version }}
            </p>
          </div>
        </div>
      </div>
    </footer>
  </main>
</div>
